// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/css/vendor-styles.css
// module id = 2816
// module chunks = 0